<template>
  <md-tab id="tab-sales-class" md-label="Sales Class" md-icon="class">
    <div class="md-layout">
      <PulseLoader :loading="!loaded" :class="{ hide: loaded }"></PulseLoader>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <template v-if="loaded">
          <div @click="chooseSales($event)" :class="`industrywide ${this.checkSalesSelector('industrywide') ? 'available' : 'unavailable' }`">Industrywide</div>
          <div @click="chooseSales($event)" :class="`smalll ${this.checkSalesSelector('Small < $5M') ? 'available' : 'unavailable' } unclicked`">Small &lt; $1-$5million</div>
          <div @click="chooseSales($event)" :class="`medium ${this.checkSalesSelector('Medium - $5m-$24.99m') ? 'available' : 'unavailable' } unclicked`">Medium - $5m-$24.99m</div>
          <div @click="chooseSales($event)" :class="`large ${this.checkSalesSelector('Large  > $25m') ? 'available' : 'unavailable' } unclicked`">Large &gt; $25m</div>
          <div @click="chooseSales($event)" :class="`half-m ${this.checkSalesSelector('> $500m') ? 'available' : 'unavailable' }`">&gt; $500m</div>
        </template>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 search_panel">
        <sidebar-search tab="sales_class" title="Favorite Sale Classes"/>
      </div>
    </div>
  </md-tab>
</template>
<script>
import SidebarSearch from './../_partials/SidebarSearch';
import axios from 'axios';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import {PulseLoader} from '@/components';
import Vue from 'vue';

export default {
  name: 'sales-class-tab',
  props: {},
  components: {
    SidebarSearch,
    PulseLoader
  },
  data() {
    return {
      route: null,
      search: 'autofill text area names...',
      apiSales: undefined,
      sales: {
        small: [],
        medium: [],
        large: [],
        '500m': '17',
        industrywide: '1',
      },
      availableSales: [],
      loaded: false,
    };
  },
  methods: {
    getData: function (name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },

    checkSalesSelector: function(name) {
      // "Small < $5M" "Medium - $5m-$24.99m" "Large  > $25m"
      let ret = false;
      if(name == "Small < $5M") { ret = this.sales['small'].length; }
      if(name == "Medium - $5m-$24.99m") { ret = this.sales['medium'].length; }
      if(name == "Large  > $25m") { ret = this.sales['large'].length; }
      
      if(this.availableSales.includes(name)) return true;
      return ret;
    },

    getSales: async function () {
      this.loaded = false;
      await this.getAvailableSales();
      this.sales = {
        small: [],
        medium: [],
        large: [],
        '500m': '17',
        industrywide: '1',
      };
      await axios
          .get(process.env.VUE_APP_API_BASE_URL + '/info/sales_classes', {params: {type: 'if', industry: '0'}})
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                  'SET_ERROR_INFO',
                  '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/sales_classes" <br>`
              );
              throw new Error('<br>' + 'Server responded with error = True <br> errorCode: ' + res.data.errorCode);
            }
            this.apiSales = res.data.data;
            this.apiSales.forEach((saleClass) => {
              let sid = parseInt(saleClass.id);
              if (sid > 1 && sid < 7) {       this.sales['small'].push([saleClass.id, saleClass.name]); }
              else if (sid > 6 && sid < 9) {  this.sales['medium'].push([saleClass.id, saleClass.name]); }
              else if (sid > 1 && sid < 13) { this.sales['large'].push([saleClass.id, saleClass.name]); }
            });
            this.loaded = true;
          });
    },
    chooseSales: async function (event) {
      let title = event.target.innerText;
      let query = event.target.className.split(' ')[0];
      let salesClass;
      let currentDiv = document.querySelector(`.${query}`);
      if (query === 'smalll') {
        salesClass = 'small';
      } else if (query === 'medium') {
        salesClass = 'medium';
      } else if (query === 'large') {
        salesClass = 'large';
      } else if (query === 'half-m') {
        salesClass = '17';
      } else if (query === 'industrywide') {
        salesClass = '1';
      } else {
        salesClass = query.substring(1);
      }
      if (!currentDiv.classList.contains('clicked')) {
        let loadingDiv = document.createElement('div');
        let loadingMount = document.createElement('div');
        loadingDiv.setAttribute('class', 'available');
        loadingDiv.appendChild(loadingMount);
        currentDiv.appendChild(loadingDiv);
        const pulseLoader = Vue.extend(PulseLoader);
        const pulseLoaderToMount = new pulseLoader({
          propsData: {
            color: 'blue',
            loading: true,
          },
        }).$mount(loadingMount);
        this.$store.commit('SET_SALES_CLASS', `${title} [${salesClass}]`);
      }
      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );
      await axios
          .post(
              process.env.VUE_APP_API_BASE_URL + this.route,
              {},
              {
                params: {
                  session_id: currentSession,
                  profile_id: this.profileId ? this.profileId : '0',
                  industry: this.getData(this.industry),
                  sales_class: this.getData(this.salesClass),
                  area: this.getData(this.marketArea),
                  years: this.$store.getters.years,
                  type:
                      this.$store.getters.type === 'Industry firms' ? 'if' : 'spif',
                },
              }
          )
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                  'SET_ERROR_INFO',
                  '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
              );
              throw new Error(
                  '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode
              );
            }
            const {id} = res.data;
            this.$store.commit('SET_PROFILE_ID', id);
          });
      while (currentDiv.firstChild != currentDiv.lastChild) {
        currentDiv.removeChild(currentDiv.lastChild);
      }
      if (
          salesClass === 'small' ||
          salesClass === 'medium' ||
          salesClass === 'large'
      ) {
        if (currentDiv.classList.contains('unclicked')) {
          currentDiv.classList.remove('unclicked');
          currentDiv.classList.add('clicked');
          this.sales[salesClass].forEach((classInfo) => {
            let elementToAppend = document.createElement('div');
            elementToAppend.setAttribute(
                'class',
                `c${classInfo[0]} ${this.availableSales.includes(classInfo[1])
                    ? 'available'
                    : 'unavailable'
                }`
            );
            elementToAppend.textContent = `${classInfo[1]}`;
            currentDiv.appendChild(elementToAppend);
          });
        } else {
          while (currentDiv.firstChild != currentDiv.lastChild) {
            currentDiv.removeChild(currentDiv.lastChild);
          }
          currentDiv.classList.remove('clicked');
          currentDiv.classList.add('unclicked');
        }
      }
    },
    getAvailableSales: async function () {
      await axios
          .get(process.env.VUE_APP_API_BASE_URL + '/info/sales_classes', {params: {type: 'if', industry: this.getData(this.industry)}})
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                  'SET_ERROR_INFO',
                  '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/sales_classes" <br>`
              );
              throw new Error('<br>' + 'Server responded with error = True <br> errorCode: ' + res.data.errorCode);
            }
            this.apiSales = res.data.data;
            let temp = [];
            this.apiSales.forEach((sales) => { temp.push(sales.name); });
            this.availableSales = temp;
          });
    },
  },
  async created() {
    if (this.$route.name === 'NewProfile')
      this.route = '/user/search_profiles/if';
    else
      this.route = '/user/search_reports/if';
    await this.getSales();
  },
  computed: {
    profileId() {
      return this.$store.getters.profileId;
    },
    industry() {
      return this.$store.getters.industry;
    },
    marketArea() {
      return this.$store.getters.marketArea;
    },
    salesClass() {
      return this.$store.getters.salesClass;
    },
  },
  watch: {
    industry(newValue, oldValue) {
      this.getSales();
    },
  },
};
</script>
<style lang="scss">
.unavailable {
  opacity: 0.5;
  color: #3c4858;
  font-size: 0.9375rem;
  cursor: not-allowed;
  margin: 16px;
}

.available {
  color: #3c4858;
  font-size: 0.9375rem;
  cursor: pointer;
  margin: 16px;
}

.available:hover {
  color: #1a7bfa;
}
</style>